<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <ng-container>
        <li class="menu-title"> {{ "SIDEBAR.collection" | translate }}</li>
       
        <li [ngClass]="{ 'mm-active' : isActive('/dashboard') }">
          <a (click)="toggleMenu($event)" routerLink="/dashboard" class="side-nav-link-ref">
            <i class="bx bxs-dashboard"></i>
            <span>   {{ "SIDEBAR.dashboard" | translate }} </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/clubs') }" *ngIf="permissionService.has('clubs-view')">
          <a (click)="toggleMenu($event)" routerLink="/clubs" class="side-nav-link-ref">
            <i class="bx bx-football"></i>
            <span>   {{ "SIDEBAR.clubs" | translate }} </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/members') }" *ngIf="permissionService.has('members-view')">
          <a (click)="toggleMenu($event)" routerLink="/members" class="side-nav-link-ref">
            <i class="bx bx-user"></i>
            <span>   {{ "SIDEBAR.members" | translate }} </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/dossiers') }" *ngIf="permissionService.has('dossiers-view')">
          <a (click)="toggleMenu($event)" routerLink="/dossiers" class="side-nav-link-ref">
            <i class="bx bx-book-open"></i>
            <span>   {{ "SIDEBAR.dossiers" | translate }} </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/agenda-task') }" *ngIf="permissionService.has('tasks-view')">
          <a (click)="toggleMenu($event)" routerLink="/agenda-task/section/progress" class="side-nav-link-ref">
            <i class='bx bx-list-ul' ></i>
            <span> 
              {{ "SIDEBAR.agenda-task" | translate }} 
              <span class="badge p-1 bg-primary float-end chat-counter">{{totalOpenTasks}}</span>
            </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/club-management') }" *ngIf="permissionService.has('communication-view')">
          <a (click)="toggleMenu($event)" routerLink="/club-management/section/progress" class="side-nav-link-ref">
            <i class='bx bx-buildings' ></i>
            <span> 
              {{ "SIDEBAR.club-management" | translate }} 
              <span class="badge p-1 bg-primary float-end chat-counter">{{totalUnreadChats}}</span>
            </span>
          </a>
        </li>

        <li [ngClass]="{ 'mm-active' : isActive('/reports') }" *ngIf="permissionService.has('reports-view')">
          <a (click)="toggleMenu($event)" routerLink="/reports" class="side-nav-link-ref">
            <i class='bx bx-bar-chart' ></i>
            <span>   {{ "SIDEBAR.reports" | translate }} </span>
          </a>
        </li>

        <li class="ng-star-inserted" [ngClass]="permissionService.hasAny(['bulk-tools-create', 'bulk-import-create']) ? '' : 'd-none'">
          <a href="javascript:void(0);"
            class="is-parent has-arrow ng-star-inserted mm-collapsed" aria-expanded="false">
            <i class='bx bx-layer' ></i>
            <span> {{ "SIDEBAR.bulk-action" | translate }} </span>
          </a>
          <ul aria-expanded="false" class="sub-menu ng-star-inserted mm-collapse">
            
            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/bulk-tools'), 'd-none' : !permissionService.has('bulk-tools-create') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/bulk-tools"> {{ "SIDEBAR.bulk-tools" | translate }} </a>
            </li>

            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/bulk-import'), 'd-none': !permissionService.has('bulk-import-create') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/bulk-import">  {{ "SIDEBAR.bulk-import" | translate }} </a>
            </li>

          </ul>
        </li>

        <li class="ng-star-inserted" [ngClass]="permissionService.hasAny(['print-log-view', 'sent-emails-view', 'workflow-data-view', 'dossiers-workflow-view']) ? '' : 'd-none'">
          <a href="javascript:void(0);"
            class="is-parent has-arrow ng-star-inserted mm-collapsed" aria-expanded="false">
            <i class="bx bx-envelope"></i>
            <span> {{ "SIDEBAR.outgoing" | translate }} </span>
          </a>
          <ul aria-expanded="false" class="sub-menu ng-star-inserted mm-collapse">
            
            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/print-log'), 'd-none' : !permissionService.has('print-log-view') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/print-log">  {{ "SIDEBAR.print-log" | translate }} </a>
            </li>

            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/sent-emails'), 'd-none': !permissionService.has('sent-emails-view') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/sent-emails">  {{ "SIDEBAR.sent-emails" | translate }} </a>
            </li>

            
            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/workflow-failed-email'), 'd-none': !permissionService.has('dossiers-workflow-view') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/workflow-failed-email">  {{ "SIDEBAR.failed-workflow-emails" | translate }} </a>
            </li>

            <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/workflows'), 'd-none': !permissionService.has('workflow-data-view') }">
              <a class="side-nav-link-ref ng-star-inserted" routerLink="/workflows">  {{ "SIDEBAR.workflow-data" | translate }} </a>
            </li>

          </ul>
        </li>

        <li class="menu-title" [ngClass]="permissionService.hasAny(['sportlink-view', 'seasons-view', 'service-fee-view', 'club-category-view', 'communication-category-view', 'task-category-view', 'dossier-category-view', 'email-template-view', 'whatsapp-template-view', 'sms-template-view', 'letter-template-view', 'workflows-email-templates-view', 'workflows-restrictions-view', 'workflows-settings-view', 'users-view', 'payment-type-view', 'user-notifications-view', 'contributie-email-templates-view']) ? '' : 'd-none'"> {{ "SIDEBAR.settings" | translate }}</li>

        <li [ngClass]="{ 'mm-active' : isActive('/users') }" *ngIf="permissionService.has('users-view')">
          <a (click)="toggleMenu($event)" routerLink="/users" class="side-nav-link-ref">
            <i class='bx bx-group' ></i>
            <span>   {{ "SIDEBAR.users" | translate }} </span>
          </a>
        </li>
        

        <li class="ng-star-inserted" [ngClass]="permissionService.hasAny(['sportlink-view', 'seasons-view', 'service-fee-view', 'club-category-view', 'communication-category-view', 'task-category-view', 'dossier-category-view', 'email-template-view', 'whatsapp-template-view', 'sms-template-view', 'letter-template-view', 'workflows-email-templates-view', 'workflows-restrictions-view', 'workflows-settings-view', 'payment-type-view', 'user-notifications-view', 'contributie-email-templates-view', 'workflows-letter-templates-view']) ? '' : 'd-none'">
          <a href="javascript:void(0);"
            class="is-parent has-arrow ng-star-inserted mm-collapsed" aria-expanded="false">
            <i class="bx bx-cog"></i>
            <span> {{ "SIDEBAR.settings" | translate }} </span>
          </a>

          <ul aria-expanded="false" class="sub-menu ng-star-inserted mm-collapse" id="settings">
            
            <li class="ng-star-inserted ng-child-link" [ngClass]="{ 'mm-active' : isActive('/sportlink'), 'd-none': !permissionService.has('sportlink-view') }">
              <a class="side-nav-link-ref ng-star-inserted" data-parent="settings" (click)="toggleMenu($event)" routerLink="/sportlink">  {{ "SIDEBAR.sportlink" | translate }} </a>
            </li>

            <li class="ng-star-inserted ng-child-link" [ngClass]="{ 'mm-active' : isActive('/seasons'), 'd-none': !permissionService.has('seasons-view') }">
              <a class="side-nav-link-ref ng-star-inserted" data-parent="settings" (click)="toggleMenu($event)" routerLink="/seasons">  {{ "SIDEBAR.seasons" | translate }} </a>
            </li>



            <li class="ng-star-inserted" [ngClass]="permissionService.hasAny(['service-fee-view', 'payment-type-view']) ? '' : 'd-none'">
              <a href="javascript:void(0);"
                class="is-parent has-arrow ng-star-inserted mm-collapsed" aria-expanded="false">
                <!-- <i class='bx bx-book'></i>  -->
                <span> {{ "SIDEBAR.payments" | translate }} </span>
              </a>
              <ul aria-expanded="false" class="sub-menu ng-star-inserted mm-collapse ng-child-dropdown">
                
                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/service-fee'), 'd-none': !permissionService.has('service-fee-view') }">
                    <a class="side-nav-link-ref ng-star-inserted" routerLink="/service-fee"> {{ "SIDEBAR.service-fee" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/payment-type'), 'd-none': !permissionService.has('payment-type-view') }">
                    <a class="side-nav-link-ref ng-star-inserted" routerLink="/payment-type"> {{ "SIDEBAR.payment-type" | translate }} </a>
                </li>

              </ul>
            </li>


            <li class="ng-star-inserted ng-child-link" [ngClass]="{ 'mm-active' : isActive('/user-notifications'), 'd-none': !permissionService.has('user-notifications-view') }">
                <a class="side-nav-link-ref ng-star-inserted" data-parent="settings" (click)="toggleMenu($event)" routerLink="/user-notifications">  {{ "SIDEBAR.user-notifications" | translate }} </a>
            </li>

            <li class="ng-star-inserted" [ngClass]="permissionService.hasAny(['club-category-view', 'communication-category-view', 'task-category-view', 'dossier-category-view']) ? '' : 'd-none'">
              <a href="javascript:void(0);"
                class="is-parent has-arrow ng-star-inserted mm-collapsed" aria-expanded="false">
                <!-- <i class='bx bx-book'></i>  -->
                <span> {{ "SIDEBAR.categories" | translate }} </span>
              </a>
              <ul aria-expanded="false" class="sub-menu ng-star-inserted mm-collapse ng-child-dropdown">
                
                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/club-category'), 'd-none': !permissionService.has('club-category-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/club-category">  {{ "SIDEBAR.club-category" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/communication-category'), 'd-none': !permissionService.has('communication-category-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/communication-category">  {{ "SIDEBAR.communication-category" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/task-category'), 'd-none': !permissionService.has('task-category-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/task-category">  {{ "SIDEBAR.task-category" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/dossier-category'), 'd-none': !permissionService.has('dossier-category-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/dossier-category">  {{ "SIDEBAR.dossier-category" | translate }} </a>
                </li>

              </ul>
            </li>

            <li class="ng-star-inserted" [ngClass]="permissionService.hasAny(['workflows-email-templates-view', 'workflows-restrictions-view', 'workflows-settings-view', 'workflows-letter-templates-view']) ? '' : 'd-none'">
              <a href="javascript:void(0);"
                class="is-parent has-arrow ng-star-inserted mm-collapsed" aria-expanded="false">
                <!-- <i class="bx bx-grid"></i> -->
                <span> {{ "SIDEBAR.workflows" | translate }} </span>
              </a>

              <ul aria-expanded="false" class="sub-menu ng-star-inserted mm-collapse ng-child-dropdown">
                
                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/workflow-email-templates'), 'd-none': !permissionService.has('workflows-email-templates-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/workflow-email-templates">  {{ "SIDEBAR.email-templates" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/workflow-letter-templates'), 'd-none': !permissionService.has('workflows-letter-templates-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/workflow-letter-templates">  {{ "SIDEBAR.letter-templates" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/workflow-restrictions'), 'd-none': !permissionService.has('workflows-restrictions-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/workflow-restrictions">  {{ "SIDEBAR.workflow-restrictions" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/workflow-settings'), 'd-none': !permissionService.has('workflows-settings-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/workflow-settings">  {{ "SIDEBAR.workflow-settings" | translate }} </a>
                </li>

              </ul>
            </li>

            <li class="ng-star-inserted" [ngClass]="permissionService.hasAny(['email-template-view', 'whatsapp-template-view', 'sms-template-view', 'letter-template-view', 'contributie-email-templates-view']) ? '' : 'd-none'">
              <a href="javascript:void(0);"
                class="is-parent has-arrow ng-star-inserted mm-collapsed" aria-expanded="false">
                <!-- <i class="bx bx-palette"></i> -->
                <span> {{ "SIDEBAR.correspondence" | translate }} </span>
              </a>
              <ul aria-expanded="false" class="sub-menu ng-star-inserted mm-collapse ng-child-dropdown">
                
                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/email-template'), 'd-none': !permissionService.has('email-template-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/email-template">  {{ "SIDEBAR.email-template" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/whatsapp-template'), 'd-none': !permissionService.has('whatsapp-template-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/whatsapp-template">  {{ "SIDEBAR.whatsapp-template" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/sms-template'), 'd-none': !permissionService.has('sms-template-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/sms-template">  {{ "SIDEBAR.sms-template" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/letter-template'), 'd-none': !permissionService.has('letter-template-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/letter-template">  {{ "SIDEBAR.letter-template" | translate }} </a>
                </li>

                <li class="ng-star-inserted" [ngClass]="{ 'mm-active' : isActive('/contributie-email-templates'), 'd-none': !permissionService.has('contributie-email-templates-view') }">
                  <a class="side-nav-link-ref ng-star-inserted" routerLink="/contributie-email-templates">  {{ "SIDEBAR.contributie-email-templates" | translate }} </a>
                </li>

              </ul>
            </li>

          </ul>
        </li>

      </ng-container>
    </ul>
  </div>

  
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <div class="sidebar-top">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>    
    </div>
  </ngx-simplebar>

  <div class="sidebar-footer">
    <div class="sidebar-footer-version">
      <span class="w-100 cursor-pointer" routerLink="/help-and-support/changelog-version"> {{ "SIDEBAR.version" | translate }} {{ appVersion ?? "0.0.0" }}</span>
    </div>

    <div class="sidebar-footer-link">
      <a routerLink="/help-and-support" (click)="toggleMenu($event)" class="side-nav-link-ref" [ngClass]="{ 'active' : isActive('/help-and-support') }">
        <i class="bx bx-support"></i>
        <span class="support-footer-span"> {{ "SIDEBAR.help-and-support" | translate }} </span>
      </a>
    </div>
  </div>
</div>
<!-- Left Sidebar End -->